import {
  CtoPermissions,
  GroupEnum,
  GroupLabelsEnum,
  GroupPermissionBody,
  GroupPermissionResponse,
  HistoryGroupPermissionChanges,
  OthersPermissions,
  PermissionGroupResponse,
  PermissionHistoryResponse,
  UserPermissionBody,
  UserPermissionByIdResponse,
  UserPermissionGrid,
  UserPermissionGroup,
} from "../../../types/permissionTypes";
import { MOCK_MV29, MOCK_MV51, MOCK_MV77 } from "../genericMocks";
import { mockUser, mockUserExternal } from "../user/user.mock";
import { allPermissionsMock, manageRequestMock } from "./permission.mock";

export const userPermissionResponseMock: UserPermissionGrid[] = [
  {
    id: 77,
    name: mockUser.name,
    email: mockUser.mail,
    position: mockUser.position,
    groups: [GroupLabelsEnum.SHAPE_ADMIN],
    vessels: [MOCK_MV29, MOCK_MV51, MOCK_MV77],
  },
];

export const userPermissionCreateMock: UserPermissionBody = {
  email: mockUser.mail,
  permissions: [{ group_id: 1, vessels: [MOCK_MV29] }],
  name: "",
  position: "",
};

export const groupPermissionBodyMock: GroupPermissionBody = {
  name: "Custom",
  permission_ids: [
    GroupEnum.CUSTOM,
    GroupEnum.SHAPE_ADMIN,
    OthersPermissions.MANAGE_REQUEST,
  ],
  recommended_position: "SHAPE_ADMIN",
};

export const groupPermissionResponseMock: GroupPermissionResponse[] = [
  {
    recommended_position: "SHAPE_ADMIN",
    id: GroupEnum.CUSTOM,
    name: "Custom",
    permissions: [],
  },
  {
    recommended_position: "exiting value2",
    id: GroupEnum.SHAPE_ADMIN,
    name: "name2",
    permissions: [],
  },
  {
    recommended_position: "",
    id: OthersPermissions.MANAGE_REQUEST,
    name: "name3",
    permissions: [],
  },
];

export const permissionGroupResponseMock: PermissionGroupResponse[] = [
  { ...groupPermissionResponseMock[0], linked_users: [] },
  { ...groupPermissionResponseMock[1], linked_users: ["user1@email.com"] },
  { ...groupPermissionResponseMock[2], linked_users: ["user2@email.com"] },
];

export const userGroupMock: UserPermissionGroup = {
  group_id: GroupEnum.CUSTOM,
  id: 24,
  permissions: [
    {
      description: "Manage request",
      name: "Manage request",
      enable: true,
      id: OthersPermissions.MANAGE_REQUEST,
    },
    {
      description: "CTO - Identification",
      name: "CTO - Identification",
      enable: true,
      id: CtoPermissions.IDENTIFICATION,
    },
  ],
  vessels: [MOCK_MV29],
};

const dateMock = new Date("2024-01-03T19:49:20.291Z");

export const groupHistoryChangesMock: HistoryGroupPermissionChanges[] = [
  {
    change_date: dateMock,
    changed_by: mockUser,
    group: {
      ...groupPermissionResponseMock[0],
      active: true,
      permissions: ["permission1"],
    },
  },
  {
    change_date: dateMock,
    changed_by: mockUser,
    group: {
      ...groupPermissionResponseMock[0],
      active: true,
      permissions: ["permission1", "permission2"],
    },
  },
  {
    change_date: dateMock,
    changed_by: mockUser,
    group: {
      ...groupPermissionResponseMock[0],
      active: true,
      permissions: ["permission1", "permission2", "permission3"],
    },
  },
];

export const userWithoutPermissionsMock: UserPermissionByIdResponse = {
  id: 77,
  name: mockUser.name,
  email: mockUser.mail,
  position: mockUser.position,
  user_groups: [
    {
      group_id: GroupEnum.CUSTOM,
      id: 7,
      vessels: [MOCK_MV29, MOCK_MV51, MOCK_MV77],
      permissions: [],
    },
  ],
};

export const requestsManagerMock: UserPermissionByIdResponse = {
  ...userWithoutPermissionsMock,
  user_groups: [
    {
      group_id: GroupEnum.CUSTOM,
      id: 7,
      vessels: [MOCK_MV51],
      permissions: [],
    },
    {
      group_id: GroupEnum.CUSTOM,
      id: 6,
      vessels: [MOCK_MV77],
      permissions: [manageRequestMock],
    },
    {
      group_id: GroupEnum.CUSTOM,
      id: 5,
      vessels: [MOCK_MV29],
      permissions: [manageRequestMock],
    },
  ],
};

export const userPermissionMock: UserPermissionByIdResponse = {
  id: 77,
  name: mockUser.name,
  email: mockUser.mail,
  position: mockUser.position,
  user_groups: [
    {
      group_id: GroupEnum.SHAPE_ADMIN,
      id: 7,
      vessels: [MOCK_MV29, MOCK_MV51, MOCK_MV77],
      permissions: allPermissionsMock,
    },
  ],
};

export const userPermissionHistoryMock: PermissionHistoryResponse = {
  changes: [
    {
      change_date: dateMock,
      changed_by: mockUser,
      user_groups: [
        {
          permissions: ["Change other user's permissions"],
          user_group: GroupLabelsEnum.CUSTOM,
          vessels: [MOCK_MV51],
        },
      ],
    },
    {
      change_date: new Date("2024-01-01T19:49:20.291Z"),
      changed_by: mockUser,
      user_groups: [
        {
          permissions: null,
          user_group: GroupLabelsEnum.OPS_MANAGER,
          vessels: [MOCK_MV77],
        },
      ],
    },
  ],
  user: mockUserExternal,
};
